<template>
   <div class="IncidentContainerBox noNum mt-2">
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                    <div
                        class="d-flex align-items-start justify-content-between">
                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate" v-if="this.OpenInModal">
                            {{PhotoObj.patientName}} - {{PatientCode}} - {{ $t('Shared.Dob') }} {{PhotoObj.dob}} {{PhotoObj.ageFormatted}} -
                             {{$t('Shared.Weight')}} {{PhotoObj.weight}} - {{$t('Shared.Height')}} {{PhotoObj.heights}}
                        </h6>

                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate" v-else>
                            {{$t('Shared.Weight')}} <span v-if="RegistrationInfo.weight">{{RegistrationInfo.weight}}</span><span v-else>{{$t('Shared.Notdefined')}}</span> -
                            {{$t('Shared.Height')}} <span v-if="RegistrationInfo.heights">{{RegistrationInfo.heights}}</span><span v-else>{{$t('Shared.Notdefined')}}</span>
                        </h6>



                        </div>
                        <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                    <b-collapse id="InfoBoxs">



                        <div class="card activeCard" v-if="this.OpenInModal">
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                        <div class="row patPhoto-container">
                                            <div class="col-md-2 patPhoto">

                                                <i
                                                    id="rm-allergic"
                                                    v-if="PhotoObj.allergies && !PhotoObj.specialPrecautions && !PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies"
                                                    variant="primary">
                                                </i>

                                                <i
                                                    id="rm-allergic"
                                                    v-if="!PhotoObj.allergies && PhotoObj.specialPrecautions && !PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.SPECIALPR')}: `+PhotoObj.specialPrecautions"
                                                    variant="primary">
                                                </i>

                                                <i
                                                    id="rm-allergic"
                                                    v-if="!PhotoObj.allergies && !PhotoObj.specialPrecautions && PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.MarsAlerts')}: `+PhotoObj.marsAlerts"
                                                    variant="primary">
                                                </i>

                                                <i
                                                    id="rm-allergic"
                                                    v-if="PhotoObj.allergies && PhotoObj.specialPrecautions && !PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies + ` / ` + $t('RigthBar.SPECIALPR') +': '+ PhotoObj.specialPrecautions"
                                                    variant="primary">
                                                </i>

                                                <i
                                                    id="rm-allergic"
                                                    v-if="PhotoObj.allergies && !PhotoObj.specialPrecautions && PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies + ` / ` + $t('RigthBar.MarsAlerts') +': '+ PhotoObj.marsAlerts"
                                                    variant="primary">
                                                </i>


                                                <i
                                                    id="rm-allergic"
                                                    v-if="!PhotoObj.allergies && PhotoObj.specialPrecautions && PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.SPECIALPR')}: `+PhotoObj.specialPrecautions + ` / ` + $t('RigthBar.MarsAlerts') +': '+ PhotoObj.marsAlerts"
                                                    variant="primary">
                                                </i>

                                                <i
                                                    id="rm-allergic"
                                                    v-if="PhotoObj.allergies && PhotoObj.specialPrecautions && PhotoObj.marsAlerts"
                                                    class="mdi mdi-alert text-warning allergies relocateIcon helpCursor"
                                                    v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+PhotoObj.allergies + ' / '+   `${$t('RigthBar.SPECIALPR')}: `+PhotoObj.specialPrecautions + ` / ` + $t('RigthBar.MarsAlerts') +': '+ PhotoObj.marsAlerts"
                                                    variant="primary">
                                                </i>

                                                <img v-if="PhotoObj.patientPhoto" v-bind:src="'data:image/'+'.'+PhotoObj.patientPhotoExtension+';base64,'+PhotoObj.patientPhoto" alt="Foto" class="patPic img-fluid" style="height: 100%;">
                                                <img v-if="(PhotoObj.patientPhoto === null || PhotoObj.patientPhoto === '') && PhotoObj.sex === 'Male'" src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">
                                                <img v-if="(PhotoObj.patientPhoto === null || PhotoObj.patientPhoto === '') && PhotoObj.sex === 'Female'" src="@/assets/images/faces/nopic-female.jpg" alt="Foto" class="photo img-fluid">


                                            </div>
                                            <div class="col-md-10">
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientName') }}</small><br>
                                                        <b>{{PhotoObj.patientName}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientCode') }}</small><br>
                                                        <b>{{PatientCode}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Dob') }}</small><br>
                                                        <b>{{PhotoObj.dob}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Age') }}</small><br>
                                                        <b>{{PhotoObj.ageFormatted}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Gender') }}</small><br>
                                                        <b>{{PhotoObj.sex}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('Shared.Weight')}}</small><br>
                                                        <b>{{PhotoObj.weight}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('Shared.Height')}}</small><br>
                                                        <b>{{PhotoObj.heights}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$tc('Shared.Program')}}</small><br>
                                                        <b>{{RegistrationInfo.programNameFormated}}</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="row mt-2">
                            <MdPatientAllergies v-if="this.PatientCode"
                                v-bind:NoUseClass="false"
                                v-bind:ModalIdAddAllergy="'AddAllergyMars'"
                                v-bind:VisibleAllergy="true"
                                v-bind:AdmissionRecordId="this.AdmissionRecordId"
                                v-bind:UseColumnDinamic="true"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="this.PatientCode.trim()"
                                v-bind:NoValidateChanges="true">
                            </MdPatientAllergies>
                            <MdPatientSpecialPrecautions v-if="this.PatientCode"
                                v-bind:NoUseClass="false"
                                v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMarsMed'"
                                v-bind:VisibleSpecialPrecautions="true"
                                v-bind:UseColumnDinamic="true"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="this.PatientCode.trim()"
                                v-bind:NoValidateChanges="true">
                            </MdPatientSpecialPrecautions>
                            <MdPatientMarsAlert v-if="this.PatientCode"
                                v-bind:UseColumnDynamic="true"
                                v-bind:ModalIdAddMarksAlert="'ModalMarsAlert'"
                                v-bind:VisibleMarsAlert="true"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="this.PatientCode.trim()">
                            </MdPatientMarsAlert>
                            <MdPatientDiagnosis v-if="this.PatientCode"
                                v-bind:UseColumnDinamic="true"
                                v-bind:VisibleDiagnosis="true"
                                v-bind:ModalIdDiagnosis="'ModalIdDiagMarsMed'"
                                v-bind:Column="'col-md-3'"
                                v-bind:PatientCode="this.PatientCode.trim()">
                            </MdPatientDiagnosis>
                        </div>
                </b-collapse>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import PatientService from '@/services/patient.service'
import DocumentManagementService from '@/services/documentmanagement.service'
import Utils from '@/common/utils'
export default {
  name: 'BoxInfoPatient',
  mixins: [DBFunctions],
  props:{
    PatientCode:String,
    AdmissionRecordId:String,
    OpenInModal:Boolean
  },
  data(){
    return{
        RegistrationInfo:{},
        PhotoObj:{patientName:"",patientPhoto:""},
    }
  },

  methods:{
      GetPhoto(){
       DocumentManagementService.GetPatientPhoto(this.PatientCode)
        .then((response) => {
          if(response.status == '200' && response.data){
            this.PhotoObj.patientPhoto = response.data?.contents;
          }
        })
        .catch((error) => {
            if (error.response) {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
        });
    },

    async getPatient() {
           await PatientService.get(this.PatientCode)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.PhotoObj = response.data;
                    this.PhotoObj.dob = Utils.formatterDateToString(this.PhotoObj.dob);
                    this.PhotoObj.patientName = this.PhotoObj.firstname+" "+this.PhotoObj.lastname;

                }
            })
            .catch((error) => {
              if (!error.response) {
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        },
  },

  async mounted(){
   await this.getPatient();
         this.GetPhoto();


    if(this.AdmissionRecordId){
        var RegistrationList = await this.getRegistrationInfoTitle(this.AdmissionRecordId);
         if(RegistrationList.length > 0){
            this.RegistrationInfo = RegistrationList[0];
            this.RegistrationInfo.age = this.RegistrationInfo.age === 0 ? "0" : this.RegistrationInfo.age;
         }

    }


  }
};
</script>


<style scoped>

.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.no-image {
  text-align: center;
  font-size: 18px;
  color: #ffffff;
}

.carouselPic{
    background-color: #FFF !important;
    border-radius: 15px 15px 0 0;
    border: 4px solid #19BEE1;
    overflow: hidden;
}
.carouselPic .carousel-item{
    background-color: #FFF !important;
}
.patPhoto .carousel-description{
    color: white !important;
    background-color: #19BEE1;
    border-radius: 0 0 15px 15px;
    height: 40px;
}
.patPhoto .carousel-description p{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    line-height: 1;
    font-size: small;
    padding: 2px 10px 2px 10px;
}
.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}

.medAdminLabel{
    padding: 0 0.8em;
    display: inline-block;
    margin-top: .4em;
    border-radius: 10px;
    font-variant-caps: all-small-caps;
    vertical-align: top !important;
    font-kerning: 5em;
    font-weight: bold;
    font-size: 0.8em;
    color: #FFF;
}
.allergicToMed{
    background-color: #F00;
    color: #FF9;
    animation: blinking 1s linear infinite;
}
.overdue{
    background-color: var(--overdue);
}
.close-to-admin{
    background-color: var(--close-to-admin);
}
.prior-to-admin{
    background-color: var(--prior-to-admin);
}
.no-pending{
    background-color: var(--no-pending);
}

@keyframes blinking {
    0%, 50% {
        color: #FF9;
    }
    100% {
        color: #F00;
    }
}
@keyframes fadingNow {
    0%, 50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.withDot::after{
    content: "●";
    color: #F00;
    position: absolute;
    top: 4px;
    left: 14px;
    animation: fadingNow 1s infinite;
}
.greenBTN{
    background-color: #0C0 !important;
    border-radius: 15px 0 0 15px !important;
    color: #6F6 !important;
}
.greenBTN:hover{
    background-color: #0F0 !important;
    box-shadow: 0 0 5px #008300;
    color: #FFF !important;
    transform: scale(1.1);
}
.redBTN{
    background-color: #C00 !important;
    border-radius: 0 15px 15px 0 !important;
    color: #F66 !important;
}
.redBTN:hover{
    background-color: #F00 !important;
    box-shadow: 0 0 5px #820000;
    color: #FFF !important;
    transform: scale(1.1);
}

/* MODAL REMAKE */
/*.zebraAccordion{
    margin: 0 1em;
}*/
.resetFontSize small{
    font-size: .95em;
}
.zebraAccordion .zebraRow .zebraItem{
    border-radius: 4px 4px 0 0;
    padding: 5px;
    width: 100%;
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.zebraAccordion .zebraRow:nth-child(odd) .zebraItem{
    background-color: #d4f7ff;
}
.zebraAccordion .zebraRow:nth-child(even) .zebraItem{
    background-color: #ecfcff;
}

.zebraAccordion .zebraRow .accordion .zebraItem.not-collapsed {
    background-color: #19BEE1;
    color: #FFF;
}
.zebraAccordion .zebraRow .accordion .zebraItem:hover {
    background-color: #64d6f0;
    color: #FFF;
}
.zItemIcon{
    width: 15%;
    margin: 0 1%;
    display: inline;
    vertical-align: middle;
}

.zItemText{
    width: 86%;
    display: inline;
    vertical-align: middle;
}
@media (max-width: 992px) {
    .zItemIcon{
        width: 10%;
    }
    .zItemText{
        width: 75%;
    }
}
.quickSave{
    color: #19BEE1;
    transition: all .3s ease-in-out;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.quickSave:hover{
    color: #FFF;
}
.zebraAccordion .zebraRow .zebraItem small{
    font-size: .7em;
}
.PRNlabel{
    background-color: #6F6;
    border-radius: 10px;
    padding: 0 10px;
    color: #060 !important;
    transition: all .3s ease-in-out;
}
.PRNlabel:hover{
    background-color: #FF9;
}
.opAT{
    opacity: .5;
}
.accordionContent{
    border-top: 0;
    background: linear-gradient(173deg, #D9F4FB, #FFF 30% );
    padding-top: 3em;
}

.giveMeds button{
    border: 4px solid #FFFFFFEE;
    transition: all .3s ease-in-out;
    cursor: pointer;
}
.redMed{
    border-radius: 0 50px 50px 0;
    border-left: 0;
    height: 50px;
    background-color: #660000;
    background: linear-gradient(-40deg, #FF0000, #660000);
    animation: spreadShadowLast 1s ease-in-out infinite;
}
.redMed:hover{
    background-color: #FF0000;
    background: linear-gradient(-40deg, #990000, #FF0000);
}
.redMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.greenMed{
    border-radius: 50px 0 0 50px;
    background-color: #008236;
    height: 50px;
    background: linear-gradient(-40deg, #008236, #003300);
    border-right: 0 !important;
    animation: spreadShadowFirst 1s ease-in-out infinite;
}
.greenMed i::before{
    font-size: 1.1em;
}
.greenMed:hover{
    background-color: #00CC00;
    background: linear-gradient(-40deg, #006600,#01d85b);
}
.greenMed:hover i::before{
    animation: spreadShadow 1s ease-in-out infinite;
}

.GivNeutral{
    opacity: 0.2;
}

.undoMedLeft{
    background-color: #666;
    background: linear-gradient(-40deg, #EEE, #CCC);
    border: 4px solid #EEE !important;
    border-right: 0 !important;
}
.undoMedLeft:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #999, #CCC);
}
.undoMedRight{
    background-color: #666;
    background: linear-gradient(-40deg, #CCC, #EEE);
    border: 4px solid #EEE !important;
    border-left: 0 !important;
}
.undoMedRight:hover{
    background-color: #999;
    background: linear-gradient(-40deg, #CCC, #999);
}
@keyframes spreadShadow {
    0%, 100% {
        text-shadow: 0 0 1px #00000099;
    }
    50% {
        text-shadow: 0 0 20px #000000FF;
    }
}
@keyframes spreadShadowFirst {
    0%, 100% {
        text-shadow: 0 0 1px #FFFFFF;
    }
    50% {
        text-shadow: 0 0 20px #FFFFFF;
    }
}
@keyframes spreadShadowLast {
    0%, 100% {
        text-shadow: 0 0 20px #FFFFFF, 0 0 20px #FFFFFF;
    }
    25% {
        text-shadow: 0 0 1px #FFFFFF, 0 0 1px #FFFFFF;
    }
}
.justSTAT{
    color: #FFF;
    background-color: #bcd9e0;
    border-radius: 10px;
    padding: 0 5px;
}
.blinkingSTAT{
    color: #FF0;
    background-color: #C00;
    border-radius: 10px;
    padding: 0 5px;
    animation: blinkSTAT 1s steps(5, start) infinite;
}

.custom-carousel .carousel-control-prev,
.custom-carousel .carousel-control-next {
  display: v-bind(showArrows ? 'block' : 'none');
}

@keyframes blinkSTAT {
to {
    visibility: hidden;
    }
}

.StockInfo {
  color: #FF0000; /* Rojo puro (hexadecimal) */
  /* O podrías usar: color: red; */
  /* O podrías usar: color: rgb(255, 0, 0); */
  font-weight: bold; /* Para hacerlo más fuerte/grueso */
  /* Si quieres aún más fuerte, puedes usar font-weight: 900; */
  cursor: pointer;
}
</style>


